import { render, staticRenderFns } from "./project-information-panel.vue?vue&type=template&id=db5e9740"
import script from "./project-information-panel.vue?vue&type=script&lang=js"
export * from "./project-information-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports